/**
 * Rotas de Navegação
 * atualização: 11/10/24 | 15h26 | inclusão de 2 novas rotas de colaborador (novo e edição)
 * atualização: 16/12/24 | 10h59 | acrescentado as rotas de login e demais do "admin"
 */



import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";

// **** todas as páginas
     // **** páginas iniciais
        import Site from "./site/pages/home";
        import PrecosCRM from "./site/pages/precoscrm";
        import LoginGlobal from "./app/Login/loginmodal";
        import NovaContaGlobal from "./app/NovaConta/novacontamodal";
        import ResetSenha from "./app/ResetSenha/resetsenha";
        import ResetSenhaCV from "./app/ResetSenha/resetsenhacv";

    // **** páginas agendex ADMIN
    // **** páginas agendex ADMIN
    // **** páginas agendex ADMIN
        // **** página login
        import LoginAdmin from "./app/Login/loginadmin";

        // **** páginas home
        import AdminHome              from "./app/AgendexAdmin/pages/Home/a_home";



    // **** páginas agendex CLIENTE
    // **** páginas agendex CLIENTE
    // **** páginas agendex CLIENTE
        // **** páginas login
            import LoginCliente     from "./app/Login/logincliente";
            import NovaContaCliente from "./app/NovaConta/novacontacliente";

        // **** páginas home
            import ClienteHome              from "./app/AgendexCliente/pages/Home/home";
            import ClienteExplorarEmpresas  from "./app/AgendexCliente/pages/ExplorarEmpresa/explorarempresas";
            import ClienteDetalheEmpresa    from "./app/AgendexCliente/pages/ExplorarEmpresa/DetalheEmpresa/detalheempresa";
            import ClienteAgendar           from "./app/AgendexCliente/pages/ExplorarEmpresa/DetalheEmpresa/Agendar/agendar";

        // **** páginas agendamentos
            import ClienteAgendamentos      from "./app/AgendexCliente/pages/Agendamentos/abertos";
            import ClienteAgendamentosConcluidos      from "./app/AgendexCliente/pages/Agendamentos/concluidos";
            import ClienteAgendamentosExcluidos       from "./app/AgendexCliente/pages/Agendamentos/excluidos";
            import ClienteAgendamentosPendentes       from "./app/AgendexCliente/pages/Agendamentos/pendentes";

        // **** páginas perfil
            import ClientePerfil        from "./app/AgendexCliente/pages/Perfil/perfil";
            import ClientePerfilFoto    from "./app/AgendexCliente/pages/Perfil/fotoperfil";
            import ClientePerfilAlterar from "./app/AgendexCliente/pages/Perfil/alterardadosperfil";
            import ClientePerfilValidaEmail from "./app/AgendexCliente/pages/Perfil/ativarconta";

        // **** páginas config
            import ClienteTrocarCidade          from "./app/AgendexCliente/pages/Configuracoes/trocarcidade";
            import ClienteFaleConosco           from "./app/AgendexCliente/pages/Configuracoes/faleconosco";
            import ClienteNotificacoesInternas  from "./app/AgendexCliente/pages/Configuracoes/notificacoesinternas";
            import ClienteNotificacoes          from "./app/AgendexCliente/pages/Notificacoes/notificacoes";


    // **** páginas agendex CLIENTE COM LINK PERSONALIZADO
    // **** páginas agendex CLIENTE COM LINK PERSONALIZADO
    // **** páginas agendex CLIENTE COM LINK PERSONALIZADO
        // perfis de links personalizados (rota pública)
            import PrestadorProfile                 from "../src/app/AgendexCliente/pages/PrestadorProfile/prestadorprofile";
            import PrestadorServicosSemColaborador  from '../src/app/AgendexCliente/pages/PrestadorProfile/prestadorservicos';
            import ProfissionaisServicos            from '../src/app/AgendexCliente/pages/PrestadorProfile/profissionaiseservicos';
            import Agendamento                      from './../src/app/AgendexCliente/pages/PrestadorProfile/profissionalagendamento';
            import ConfirmacaoAgendamento           from "./app/AgendexCliente/pages/PrestadorProfile/profissionalconfirmacaoagendamento";
            import PrestadorAgendamento             from './../src/app/AgendexCliente/pages/PrestadorProfile/prestadoragendamento';
            import PrestadorConfirmacaoAgendamento  from "./app/AgendexCliente/pages/PrestadorProfile/prestadorconfirmacaoagendamentos";
    

    // **** páginas agendex PRESTADOR
    // **** páginas agendex PRESTADOR
    // **** páginas agendex PRESTADOR
        // **** páginas login
            import LoginPrestador from "./app/Login/loginprestador";
            import NovaContaPrestador from "./app/NovaConta/novacontaprestador";

        // **** páginas home
            import PrestadorHome               from "./app/AgendexPrestador/pages/Home/p_home";
            import PrestadorCadastrarEmpresa   from "./app/AgendexPrestador/pages/Empresa/p_cadastrarempresa";

        // **** páginas agendamentos
            import PrestadorAgendamentos                from "./app/AgendexPrestador/pages/Agendamentos/p_abertos";
            import PrestadorAgendamentosConcluidos      from "./app/AgendexPrestador/pages/Agendamentos/p_concluidos";
            import PrestadorAgendamentosExcluidos       from "./app/AgendexPrestador/pages/Agendamentos/p_excluidos";
            import PrestadorAgendamentosPendentes       from "./app/AgendexPrestador/pages/Agendamentos/p_pendentes";
        
        // **** páginas config
            import PrestadorNotificacoesInternas  from "./app/AgendexPrestador/pages/Configuracoes/p_notificacoesinternas";

        // **** páginas perfil
            import PrestadorPerfil              from "./app/AgendexPrestador/pages/Perfil/p_perfil";
            import PrestadorPerfilValidaEmail   from "./app/AgendexPrestador/pages/Perfil/p_ativarconta";

        // **** páginas Empresa
            import PrestadorDetalheEmpresa              from "./app/AgendexPrestador/pages/Empresa/p_detalheempresa";
            import PrestadorServicos                    from "./app/AgendexPrestador/pages/Empresa/Servicos/p_servicos";
            import PrestadorRegras                      from "./app/AgendexPrestador/pages/Empresa/Regras/p_regras";
            import PrestadorHorarios                    from "./app/AgendexPrestador/pages/Empresa/Regras/Horarios/p_horarios";
            import PrestadorFeriados                    from "./app/AgendexPrestador/pages/Empresa/Regras/Feriados/p_feriados";
            import PrestadorColaboradores               from "./app/AgendexPrestador/pages/Empresa/Colaboradores/p_colaboradores";
            import PrestadorColaboradorNovo             from "./app/AgendexPrestador/pages/Empresa/Colaboradores/p_colaborador_novo";
            import PrestadorColaboradorEditar           from "./app/AgendexPrestador/pages/Empresa/Colaboradores/p_colaborador_editar";
            import PrestadorColaboradoresServicos       from "./app/AgendexPrestador/pages/Empresa/Colaboradores/p_colaboradores_servicos";
            import PrestadorColaboradoresHorarios       from "./app/AgendexPrestador/pages/Empresa/Colaboradores/p_colaboradores_horarios";

    // **** páginas agendex PRESTADOR/COLABORADOR
    // **** páginas agendex PRESTADOR/COLABORADOR
    // **** páginas agendex PRESTADOR/COLABORADOR
        // **** páginas home
            import ColaboradorHome               from "./app/AgendexColaborador/pages/Home/pc_home";

        // **** páginas agendamentos
            import ColaboradorAgendamentos                from "./app/AgendexColaborador/pages/Agendamentos/pc_abertos";
            import ColaboradorAgendamentosConcluidos      from "./app/AgendexColaborador/pages/Agendamentos/pc_concluidos";
            import ColaboradorAgendamentosExcluidos       from "./app/AgendexColaborador/pages/Agendamentos/pc_excluidos";
            import ColaboradorAgendamentosPendentes       from "./app/AgendexColaborador/pages/Agendamentos/pc_pendentes";

        // **** páginas perfil
            import ColaboradorPerfil              from "./app/AgendexColaborador/pages/Perfil/pc_perfil";
            import ColaboradorPerfilValidaEmail   from "./app/AgendexColaborador/pages/Perfil/pc_ativarconta";



    // ********* este componente valida se a rota protegida pode ser usada ou não *********
        import SecureRoute from "./app/Context/privaterouter";
    // ********* este componente valida se a rota protegida pode ser usada ou não *********

function Rotas(){

    return <BrowserRouter>
            <Routes>
                {/* *** rotas públicas *** */}
                    <Route path="/" element={<Site />} />
                    <Route path="/precos" element={<PrecosCRM />} />
                    <Route exact path="/app/login"                  element={<LoginGlobal />} />
                    <Route exact path="/app/login/admin"            element={<LoginAdmin />} />
                    <Route exact path="/app/login/cliente"          element={<LoginCliente />} />
                    <Route exact path="/app/login/prestador"        element={<LoginPrestador />} />
                    <Route exact path="/app/novaconta"              element={<NovaContaGlobal />} />
                    <Route exact path="/app/novaconta/cliente"      element={<NovaContaCliente />} />
                    <Route exact path="/app/novaconta/prestador"    element={<NovaContaPrestador />} />
                    <Route exact path="/app/resetsenha"             element={<ResetSenha />} />
                    <Route exact path="/app/resetsenha/cv"          element={<ResetSenhaCV />} />

                {/* *** rotas protegidas *** */}

                    {/* ***** app admin **** */}
                    {/* ***** app admin **** */}
                    {/* ***** app admin **** */}
                    {/* ***** app admin **** */}

                        {/* ****** 1 páginas - home - admin ********** */}
                            <Route path="/app/admin/home" element={
                                <SecureRoute>
                                    <AdminHome/> 
                                </SecureRoute>
                            } />
                        {/* ****** 1 páginas - home - admin ********** */}

                    {/* ***** app cliente **** */}
                    {/* ***** app cliente **** */}
                    {/* ***** app cliente **** */}
                    {/* ***** app cliente **** */}

                        {/* ****** 4 páginas - home - cliente ********** */}
                            <Route path="/app/cliente/home" element={
                                <SecureRoute>
                                    {/* <AutoLogout /> */}
                                    <ClienteHome/> 
                                </SecureRoute>
                            } />
                            <Route path="/app/cliente/home/explorar" element={
                                <SecureRoute>
                                    <ClienteExplorarEmpresas/> 
                                </SecureRoute>
                            } />
                            <Route path="/app/cliente/home/explorar/empresa" element={
                                <SecureRoute>
                                    <ClienteDetalheEmpresa/> 
                                </SecureRoute>
                            } />
                            <Route path="/app/cliente/home/explorar/empresa/agendar" element={
                                <SecureRoute>
                                    <ClienteAgendar/> 
                                </SecureRoute>
                            } />
                        {/* ****** 4 páginas - home - cliente ********** */}

                        {/* ****** 4 páginas - agendamentos - cliente ********** */}
                            <Route path="/app/cliente/agendamentos/abertos" element={
                                <SecureRoute>
                                    <ClienteAgendamentos/> 
                                </SecureRoute>
                            } />
                            <Route path="/app/cliente/agendamentos/concluidos" element={
                                <SecureRoute>
                                    <ClienteAgendamentosConcluidos/> 
                                </SecureRoute>
                            } />
                            <Route path="/app/cliente/agendamentos/excluidos" element={
                                <SecureRoute>
                                    <ClienteAgendamentosExcluidos/> 
                                </SecureRoute>
                            } />
                            <Route path="/app/cliente/agendamentos/pendentes" element={
                                <SecureRoute>
                                    <ClienteAgendamentosPendentes/> 
                                </SecureRoute>
                            } />
                        {/* ****** 4 páginas - agendamentos - cliente ********** */}

                        {/* ****** 4 páginas - perfil - cliente ********** */}
                            <Route path="/app/cliente/perfil" element={
                                <SecureRoute>
                                    <ClientePerfil/> 
                                </SecureRoute>
                            } />
                            <Route path="/app/cliente/perfil/foto" element={
                                <SecureRoute>
                                    <ClientePerfilFoto/> 
                                </SecureRoute>
                            } />
                            <Route path="/app/cliente/perfil/alterar" element={
                                <SecureRoute>
                                    <ClientePerfilAlterar/> 
                                </SecureRoute>
                            } />
                            <Route path="/app/cliente/perfil/cv" element={
                                <SecureRoute>
                                    <ClientePerfilValidaEmail/> 
                                </SecureRoute>
                            } />
                        {/* ****** 4 páginas - perfil - cliente ********** */}


                        {/* ****** 4 páginas menu 3 pontinhos - configurações - cliente ********** */}
                            <Route path="/app/cliente/config/trocarcidade" element={
                                <SecureRoute>
                                    <ClienteTrocarCidade/> 
                                </SecureRoute>
                            } />
                            <Route path="/app/cliente/config/faleconosco" element={
                                <SecureRoute>
                                    <ClienteFaleConosco/> 
                                </SecureRoute>
                            } />
                            <Route path="/app/cliente/config/notificacoes" element={
                                <SecureRoute>
                                    <ClienteNotificacoesInternas/> 
                                </SecureRoute>
                            } />
                            <Route path="/app/cliente/notificacoes" element={
                                <SecureRoute>
                                    <ClienteNotificacoes/> 
                                </SecureRoute>
                            } />
                        {/* ****** 4 páginas menu 3 pontinhos - configurações - cliente ********** */}

                    {/* *** app cliente link personalizado ***** */}
                    {/* *** app cliente link personalizado ***** */}
                    {/* *** app cliente link personalizado ***** */}
                    {/* *** app cliente link personalizado ***** */}

                        {/* *** rota para links personalizados *** */}
                            <Route path="agendar/:linkPersonalizado" element={<PrestadorProfile />} />
                        {/* *** rota para links personalizados *** */}

                        {/* *** novas rotas para o processo de agendamento COM colaboradores *** */}
                            <Route path="/agendar/:linkpersonalizado/:id/profissionais"                                                 element={<ProfissionaisServicos />} />
                            <Route path="/agendar/:linkpersonalizado/:id/profissional/:profId/servico/:servId/agendamento"              element={<Agendamento />} />
                            <Route path="/agendar/:linkpersonalizado/:id/profissional/:profId/servico/:servId/agendamento/:reservaId"   element={<ConfirmacaoAgendamento />} />
                        {/* *** novas rotas para o processo de agendamento COM colaboradores *** */}

                        {/* *** novas rotas para o processo de agendamento sem colaboradores *** */}
                            <Route path="/agendar/:linkpersonalizado/:id/servico"                                   element={<PrestadorServicosSemColaborador />} />
                            <Route path="/agendar/:linkpersonalizado/:id/servico/:servId/agendamento/"              element={<PrestadorAgendamento />} />
                            <Route path="/agendar/:linkpersonalizado/:id/servico/:servId/agendamento/:reservaId"    element={<PrestadorConfirmacaoAgendamento />} />

                        {/* *** novas rotas para o processo de agendamento *** */}

                    {/* *** app cliente link personalizado ***** */}
                    {/* *** app cliente link personalizado ***** */}
                    {/* *** app cliente link personalizado ***** */}
                    {/* *** app cliente link personalizado ***** */}


                    {/* *** app prestador ***** */}
                    {/* *** app prestador ***** */}
                    {/* *** app prestador ***** */}
                    {/* *** app prestador ***** */}

                        {/* ****** 2 páginas home - prestador ********** */}
                            <Route path="/app/prestador/home" element={
                                <SecureRoute>
                                    <PrestadorHome/> 
                                </SecureRoute>
                            } />
                            <Route path="/app/prestador/perfil/cadastrarempresa" element={
                                <SecureRoute>
                                    <PrestadorCadastrarEmpresa/> 
                                </SecureRoute>
                            } />
                        {/* ****** 2 páginas home - prestador ********** */}

                        {/* ****** 7 páginas - empresa - prestador ********** */}
                            <Route path="/app/prestador/empresa" element={
                                <SecureRoute>
                                    <PrestadorDetalheEmpresa/> 
                                </SecureRoute>
                            } />
                            <Route path="/app/prestador/empresa/servicos" element={
                                <SecureRoute>
                                    <PrestadorServicos/> 
                                </SecureRoute>
                            } />
                            <Route path="/app/prestador/empresa/regras" element={
                                <SecureRoute>
                                    <PrestadorRegras/> 
                                </SecureRoute>
                            } />
                            <Route path="/app/prestador/empresa/regras/horarios" element={
                                <SecureRoute>
                                    <PrestadorHorarios/> 
                                </SecureRoute>
                            } />
                            <Route path="/app/prestador/empresa/regras/feriados" element={
                                <SecureRoute>
                                    <PrestadorFeriados/> 
                                </SecureRoute>
                            } />
                            <Route path="/app/prestador/empresa/colaboradores" element={
                                <SecureRoute>
                                    <PrestadorColaboradores/> 
                                </SecureRoute>
                            } />
                            <Route path="/app/prestador/empresa/colaboradores/novo" element={
                                <SecureRoute>
                                    <PrestadorColaboradorNovo/> 
                                </SecureRoute>
                            } />
                            <Route path="/app/prestador/empresa/colaboradores/:id" element={
                                <SecureRoute>
                                    <PrestadorColaboradorEditar />
                                </SecureRoute>
                            } />
        
                            <Route path="/app/prestador/empresa/colaboradores/servicos" element={
                                <SecureRoute>
                                    <PrestadorColaboradoresServicos/> 
                                </SecureRoute>
                            } />
                            <Route path="/app/prestador/empresa/colaboradores/horarios" element={
                                <SecureRoute>
                                    <PrestadorColaboradoresHorarios/> 
                                </SecureRoute>
                            } />
                        {/* ****** 7 páginas - empresa - prestador ********** */}


                        {/* ****** 4 páginas agendamentos - prestador ********** */}
                            <Route path="/app/prestador/agendamentos/abertos" element={
                                <SecureRoute>
                                    <PrestadorAgendamentos/> 
                                </SecureRoute>
                            } />
                            <Route path="/app/prestador/agendamentos/concluidos" element={
                                <SecureRoute>
                                    <PrestadorAgendamentosConcluidos/> 
                                </SecureRoute>
                            } />
                            <Route path="/app/prestador/agendamentos/excluidos" element={
                                <SecureRoute>
                                    <PrestadorAgendamentosExcluidos/> 
                                </SecureRoute>
                            } />
                            <Route path="/app/prestador/agendamentos/pendentes" element={
                                <SecureRoute>
                                    <PrestadorAgendamentosPendentes/> 
                                </SecureRoute>
                            } />
                        {/* ****** 4 páginas agendamentos - prestador ********** */}


                        {/* ****** 2 páginas perfil - prestador ********** */}
                            <Route path="/app/prestador/perfil" element={
                                <SecureRoute>
                                    <PrestadorPerfil/> 
                                </SecureRoute>
                            } />
                            <Route path="/app/prestador/perfil/cv" element={
                                <SecureRoute>
                                    <PrestadorPerfilValidaEmail/> 
                                </SecureRoute>
                            } />
                        {/* ****** 2 páginas perfil - prestador ********** */}

                        {/* ****** 1 página menu 3 pontinhos - configurações - prestador ********** */}
                            <Route path="/app/prestador/config/notificacoes" element={
                                <SecureRoute>
                                    <PrestadorNotificacoesInternas/> 
                                </SecureRoute>
                            } />
                        {/* ****** 1 página menu 3 pontinhos - configurações - prestador ********** */}

                    {/* *** app prestador ***** */}
                    {/* *** app prestador ***** */}
                    {/* *** app prestador ***** */}

                    {/* *** app prestador/colaborador ***** */}
                    {/* *** app prestador/colaborador ***** */}
                    {/* *** app prestador/colaborador ***** */}
                    {/* *** app prestador/colaborador ***** */}

                        {/* ****** 1 páginas home - colaborador ********** */}
                            <Route path="/app/colaborador/home" element={
                                <SecureRoute>
                                    <ColaboradorHome/> 
                                </SecureRoute>
                            } />
                        {/* ****** 1 páginas home - colaborador ********** */}

                        {/* ****** 4 páginas agendamentos - colaborador ********** */}
                        <Route path="/app/colaborador/agendamentos/abertos" element={
                                <SecureRoute>
                                    <ColaboradorAgendamentos/> 
                                </SecureRoute>
                            } />
                            <Route path="/app/colaborador/agendamentos/concluidos" element={
                                <SecureRoute>
                                    <ColaboradorAgendamentosConcluidos/> 
                                </SecureRoute>
                            } />
                            <Route path="/app/colaborador/agendamentos/excluidos" element={
                                <SecureRoute>
                                    <ColaboradorAgendamentosExcluidos/> 
                                </SecureRoute>
                            } />
                            <Route path="/app/colaborador/agendamentos/pendentes" element={
                                <SecureRoute>
                                    <ColaboradorAgendamentosPendentes/> 
                                </SecureRoute>
                            } />
                        {/* ****** 4 páginas agendamentos - colaborador ********** */}                        

                        {/* ****** 2 páginas perfil - colaborador ********** */}
                        <Route path="/app/colaborador/perfil" element={
                                <SecureRoute>
                                    <ColaboradorPerfil/> 
                                </SecureRoute>
                            } />
                            <Route path="/app/colaborador/perfil/cv" element={
                                <SecureRoute>
                                    <ColaboradorPerfilValidaEmail/> 
                                </SecureRoute>
                            } />
                        {/* ****** 2 páginas perfil - colaborador ********** */}

                    {/* *** app prestador/colaborador ***** */}
                    {/* *** app prestador/colaborador ***** */}
                    {/* *** app prestador/colaborador ***** */}
                    {/* *** app prestador/colaborador ***** */}

                {/* *** rota para demais links *** */}
                    <Route path="*" element={<Navigate to="/app/login" />} />

            </Routes>
    </BrowserRouter>
}

export default Rotas;